import React from '../lib/react'
import { Icon } from 'antd'

export default function(props){
  let iconText = (
    <span>
      <Icon type={props.type} style={{ marginRight: 8 }} />
      {props.text}
    </span>
  );
  if (props.component) {
    iconText = (
      <span>
        <Icon component={props.component} style={{ marginRight: 8 }} />
        {props.text}
      </span>
    );
  }
  return iconText;
}


// WEBPACK FOOTER //
// ./src/components/IconText.js